import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 18, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay, ease: [0.2, 0.7, 0.2, 1] }}
    >
      {children}
    </Comp>
  );
};

export const Marquee = ({ items, className = "", reverse = false, speed = 30, separator }) => {
  const row = (
    <div className="marquee-group" aria-hidden="true">
      {items.map((it, i) => (
        <span key={i} className="marquee-item">
          {it}
          {separator}
        </span>
      ))}
    </div>
  );
  return (
    <div className={`marquee ${className}`}>
      <div
        className={`marquee-track ${reverse ? "marquee-reverse" : ""}`}
        style={{ animationDuration: `${speed}s` }}
      >
        {row}
        {row}
      </div>
    </div>
  );
};

export const Kicker = ({ children, light = false, testid }) => (
  <p
    data-testid={testid}
    className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.22em] flex items-center gap-3 ${
      light ? "text-bone/70" : "text-ink/70"
    }`}
  >
    <span className="inline-block w-8 h-[2px] bg-hammer-red" />
    {children}
  </p>
);
